import './babylonjs/css/custom.css'
import { StudioErrorBoundary } from './babylonjs/components/ErrorBoundary'
import { AppContext } from './babylonjs/libs/context'
import { useStudio } from './babylonjs/libs/hooks'
import { ICompletedContextState } from './babylonjs/type/modelType'
import Main from './Main'

function App() {
  const context = useStudio()

  return (
    <AppContext.Provider value={context as ICompletedContextState}>
      <div>
        <StudioErrorBoundary>
          <Main />
        </StudioErrorBoundary>
      </div>
    </AppContext.Provider>
  )
}

export default App
